import { jsx } from "react/jsx-runtime";
import { Item as Item$1 } from "./Item.js";
import { SkeletonThumbnail } from "./SkeletonThumbnail.js";
import { SkeletonText } from "./SkeletonText.js";
function Item({
  isSubtextShow = false,
  isThumbnailShow = false,
  ...props
}) {
  const thumbnail = isThumbnailShow ? /* @__PURE__ */ jsx(SkeletonThumbnail, {}) : void 0;
  const subtext = isSubtextShow ? /* @__PURE__ */ jsx(SkeletonText, {
    variant: "secondary"
  }) : void 0;
  return /* @__PURE__ */ jsx(Item$1, {
    thumbnail,
    subtext,
    ...props,
    children: /* @__PURE__ */ jsx(SkeletonText, {})
  });
}
export {
  Item
};
//# sourceMappingURL=Item7.js.map
